<template>
	<v-card>
		<v-card-title
			class="d-flex align-center"
		>
			<translate>
				Versions
			</translate>
			<v-spacer />
			<v-btn
				v-can="'productversion.create'"
				color="primary"
				variant="flat"
				prepend-icon="$plus"
				@click="goToCreate"
			>
				<translate>Create New Version</translate>
			</v-btn>
		</v-card-title>
		<v-card-text
			class="pb-0"
		>
			<v-data-table
				:headers="headers"
				:items="productVersions"
			>
				<template #item.id="{ item }">
					<a
						:href="`/bo/products/view?id=${productId}&productversion=${item.id}`"
					>
						{{ item.id }}
					</a>
				</template>
				<template #item.active="{ item }">
					{{ isActive(item.validfrom, item.validuntil) ? 'Yes' : 'No' }}
				</template>
				<template #item.copy="{ item }">
					<confirm-dialog
						@confirm="copy(item.id)"
					>
						<template #activator="{ props }">
							<v-btn
								color="primary"
								:loading="loading"
								:disabled="copiesCreated[item.id]"
								variant="text"
								prepend-icon="$copy"
								v-bind="props"
							>
								Create Copy
							</v-btn>
						</template>
					</confirm-dialog>
				</template>
			</v-data-table>
		</v-card-text>
	</v-card>
</template>

<script>
import {
	axios,
} from '../../services/axios-service';
import ConfirmDialog from './ConfirmDialog.vue';

export default {
	name: 'ProductVersions',
	components: {
		ConfirmDialog,
	},

	props: {
		productId: {
			type: Number,
			required: true
		}
	},

	emits: ['test', 'copy',],

	data () {
		return {
			productVersions: [],
			copiesCreated: [],
			loading: false
		};
	},

	computed: {
		headers () {
			return [
				{
					title: 'ID',
					value: 'id',
				},
				{
					title: this.$gettext('Valid From'),
					value: 'validfrom',
				},
				{
					title: this.$gettext('Valid To'),
					value: 'validuntil',
				},
				{
					title: this.$gettext('Active'),
					value: 'active'
				},
				{
					title: this.$gettext('Copy Product Version'),
					value: 'copy'
				},
			];
		}
	},

	mounted () {
		this.getProductVersions();
	},

	methods: {
		/**
		 * Sets location to the product version creation route
		 *
		 * @returns {void}
		 */
		goToCreate () {
			window.location.href = `/bo/products/newversion?id=${this.productId}`;
		},
		/**
		 * @param {Date} from
		 * @param {Date} to
		 *
		 * @returns {boolean}
		 */
		isActive (from, to) {
			const fromDate = new Date(from);
			const toDate = new Date(to);
			const today = new Date();

			return fromDate < today && today < toDate;
		},

		/**
		 * Create a carbon copy of selected product version
		 *
		 * @param {number} id
		 */
		copy (id) {
			this.loading = true;
			axios.post('/api/v0/productversions/copy', {
				'productVersionId': id
			}).then(() => {
				this.copiesCreated[id] = true;
				this.$emit('copy');
				this.getProductVersions();
			}).finally(() => {
				this.loading = false;
			});
		},


		/**
		 * Get product versions from API
		 */
		getProductVersions () {
			this.$emit('test');
			axios.get(`/api/v0/productversions?product_id=${this.productId}`).then(({
				data
			}) => {
				this.productVersions = data;
			});
		}
	}
};
</script>

<style scoped>

</style>
